import { render, staticRenderFns } from "./Dynamics.vue?vue&type=template&id=600be686&scoped=true&"
import script from "./Dynamics.vue?vue&type=script&lang=js&"
export * from "./Dynamics.vue?vue&type=script&lang=js&"
import style0 from "./Dynamics.vue?vue&type=style&index=0&id=600be686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600be686",
  null
  
)

export default component.exports